import React  from 'react';
import { endpoints } from '../../utils/Constants';
import { Route, useParams } from 'react-router-dom';
import AircraftDetail from '../Editors/AircraftDetail';
import ManageEntityList from './ManageEntityList';
import { useAuth } from '../../Services/AuthContext';
import ClientModal from '../Models/ClientModal';
import entities from '../../utils/entities';


const SupplierAircraftList = ({route, parentHeight, headerHeight }) => {
    const { supplierId } = useParams();
    const [auth] = useAuth(); 
    //const sid = auth.role=== "Admin" ? supplierId : auth.supplierId;
    entities.aircraft.getByStatus = ({ status }) => {
        return endpoints.getAircraftByStatus + (supplierId?supplierId:auth.supplierId) + '/' + status;
    };
    entities.aircraft.newItem =  () => {
        return {
            supplierId: supplierId,
        };
    }
    return <React.Fragment><ManageEntityList route={route} entity={entities.aircraft} headerHeight={headerHeight} parentHeight={parentHeight} />
        <Route path={route + '/:aircraftId'} render={() => <ClientModal entity={entities.aircraft} route={route} itemParam='aircraftId'> <AircraftDetail route={route} /></ClientModal>}/>
    </React.Fragment>
}
export default SupplierAircraftList;
